import { render, staticRenderFns } from "./ValidatedVendorCodeGuide.vue?vue&type=template&id=325bc8d7&scoped=true&"
import script from "./ValidatedVendorCodeGuide.vue?vue&type=script&lang=js&"
export * from "./ValidatedVendorCodeGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325bc8d7",
  null
  
)

export default component.exports